export default "__VITE_ASSET__Bu$sS7lU__"